
styles += """
  .contact_bg {
    /* background-color: #f6f6f6; */
    /* background-image: url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23aaa9ac' fill-opacity='0.4' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E");*/

  }

  .contact_form_wrapper {
    background-color: white;
    max-width: 800px;
    margin: auto;
    padding: 60px 80px;
    box-shadow: 0 1px 3px rgba(0,0,0,.4);
    border-radius: 16px;
  }

  @media (max-width: 500px) {
    .contact_form_wrapper {
      padding: 32px 32px;
    }
  }

  [data-widget="Contact"] button:disabled {
    opacity: .4;
    pointer-events: none;
    cursor: auto;
  }


""" 
window.Contact = ReactiveComponent
  displayName: 'Contact'

  render: -> 
    @local.current_form ?= 0

    DIV null,

      @heading()

      # @form_chooser()

      DIV 
        className: 'contact_bg'

        @form()

        # @letter()

        @people()

  heading: -> 
    DIV 
      style: 
        paddingTop: 40
        width: "var(--SAAS_PAGE_WIDTH)"
        margin: 'auto'
        textAlign: 'center'

      H1
        className: 'main_callout condensed'

        "Hi friend, how can we help?"

      DIV 
        style: 
          fontSize: 18
          color: 'white'
          marginTop: 8

        'Please introduce yourself, we’d be delighted to hear from you.'

  form_chooser: -> 
    set_form = => 
      loc = fetch 'location'
      loc.query_params.form = forms[@local.current_form].id 
      save loc 

    if !@local.current_form?
      loc = fetch 'location'
      if loc.query_params.form 
        for form, idx in forms 
          if form.id == loc.query_params.form 
            @local.current_form = idx 
            break 
      @local.current_form ||= 0

    DIV 
      style: 
        position: 'relative'
        textAlign: 'center'
        top: 40

      SELECT 
        className: 'unstyled'
        style: 
          fontSize: 24
          padding: '28px 40px'
          fontWeight: 400
          backgroundSize: '24px 20px'
          backgroundColor: 'white'
          border: '1px solid #979797'
          borderRadius: 32
        value: @local.current_form
        onChange: (e) => 
          @local.current_form = e.target.value 
          save @local
          set_form()
          document.activeElement.blur()

        for n,idx in forms
          OPTION
            key: idx 
            value: idx
            style: {}

            n.question

  form: -> 

    current_form = forms[@local.current_form]

    disabled = false 
    for field in current_form.fields
      if !field.optional && !(@local[field.label]?.length > 0)
        disabled = true

    submit_click = (e) => 
      e.preventDefault()
      
      c = 
        key: '/new/contact_us'

      for p in @refs.form.elements when p.name.length > 0
        c[p.name] = p.value 

      @local.errors = null
      @local.successful = null 
      save c, (resp) => 
        if c.errors.length > 0
          @local.errors = c.errors
        else 
          @local.successful = true

          if !@logged_conversion
            plausibleEvent?('Contact')
            @logged_conversion = true
            
        save @local
    DIV 
      style: 
        paddingTop: 48
        paddingBottom: 110

      DIV 
        className: 'contact_form_wrapper'

        FORM 
          action: '/contact_us'
          method: 'post'   
          ref: 'form'       

          for field in current_form.fields
            do (field) =>
              DIV 
                key: field.label
                style: 
                  paddingBottom: 24

                LABEL 
                  style: 
                    fontSize: 20
                    display: 'block'
                    paddingBottom: 2
                  htmlFor: slugify field.label
                  field.label

                if field.form 
                  field.form()

                else 
                  field.tag 
                    name: slugify field.label
                    id: slugify field.label
                    required: if !field.optional then true
                    onChange: (e) => 
                      @local[field.label] = e.target.value
                      save @local

                    style: 
                      width: '100%'
                      fontSize: 22
                      padding: '4px 8px'
                      border: '1px solid #ddd'
                      height: if field.tag == TEXTAREA then 100
                      resize: if field.tag == TEXTAREA then 'vertical'

                if !field.optional
                  DIV 
                    style: 
                      fontSize: 10
                      color: '#777'
                    'required'

          DIV 
            style: 
              position: 'relative'
              top: 20
              textAlign: 'center'

            INPUT 
              type: 'hidden'
              name: 'inquiry'
              value: current_form.question

            # INPUT 
            #   type: 'hidden'
            #   value: arest.csrf()
            #   name: 'authenticity_token'

            if @local.errors
              for error in @local.errors 

                DIV 
                  style: 
                    color: 'red'
                    fontSize: 14
                    paddingTop: 20                    
                  error 

            if @local.successful
              DIV 
                style: 
                  backgroundColor: primary_color()
                  color: 'white'
                  fontSize: 18
                  padding: 20
                'Thank you for your message. We will be in touch.'

            else 
              BUTTON
                disabled: disabled
                style: _.extend {}, big_button(), 
                  width: '100%'
                onClick: submit_click

                'Deliver to Consider.it'


  # letter: -> 
  #   height = 390 * SAAS_PAGE_WIDTH() / 1160
  #   width = 1160 * SAAS_PAGE_WIDTH() / 1160

  #   full = SAAS_PAGE_WIDTH() > 960

  #   DIV 
  #     style: 
  #       backgroundColor: 'white'

  #     DIV 
  #       style: 
  #         position: 'relative'
  #         top: -height / 2
  #         backgroundColor: 'white'
  #         margin: 'auto'
  #         width: width
  #         height: if full then height
  #         boxShadow: '0 1px 3px rgba(0,0,0,.4)'
  #         textAlign: if !full then 'center'
  #         padding: if !full then '40px 40px'

  #       DIV 
  #         style:  
  #           position: if full then 'absolute'
  #           left: 50
  #           top: 30
  #           fontSize: 24
  #           fontWeight: 600
  #           color: if !full then primary_color()

  #         'Shy about filling out a form? '
  #         if full 
  #           BR null
  #         'Mail us a nice letter instead!'

  #       DIV 
  #         style: css.crossbrowserify
  #           position: if full then 'absolute'
  #           left: '25%'
  #           top: '40%'
  #           paddingTop: if !full then 50
  #           fontSize: 24
  #           fontWeight: 600
  #           display: 'flex'
  #           flexDirection: if !full then 'column'

  #         DIV 
  #           style: css.crossbrowserify
  #             flex: '1 1 auto'

  #           DIV 
  #             style: {}
  #             'Deliver Electronically'

  #           A 
  #             href: 'mailto:hello@consider.it'
  #             style: 
  #               textDecoration: 'underline'
  #               fontWeight: 400
  #               fontSize: if full then 22 else 16
  #             'hello@consider.it'

  #         DIV 
  #           style: css.crossbrowserify
  #             flex: '1 1 auto'
  #             padding: 20
  #             fontWeight: 400
  #           'or'

  #         DIV 
  #           style: css.crossbrowserify
  #             flex: '1 1 auto'
  #             padding: '0px 20px'

  #           DIV 
  #             style: {}
  #             'via Postal Service'

  #           DIV 
  #             style: 
  #               fontWeight: 400
  #               fontSize: if full then 22 else 16

  #             'Consider.it' 
  #             BR null
  #             '2615 SE 27th Av.'
  #             BR null
  #             'Portland, OR 97202'

  #       if full 
  #         DIV 
  #           style: 
  #             position: 'absolute'
  #             right: 20
  #             top: 16

  #           IMG 
  #             src: asset('product_page/wwstamp.png')
  #             width: SAAS_PAGE_WIDTH() * 84 / 1160
  #             height: SAAS_PAGE_WIDTH() * 132 / 1160


  people: ->
    acks = acknowledgements

    num = Math.round(Math.random() * 100) % 3

    DIV 
      id: 'about_us'
      className: 'acknowledgements'

      for ack, idx in [acks.travis, acks.core, acks.early]
        pic = ack.pics[num] or ack.pics[0]

        DIV 
          key: ack.text
          className: "acknowledgement"
          style: 
            backgroundImage: "url(#{asset("product_page/acknowledgements/#{pic.url}")})"
            marginTop: if idx > 0 then -93

          DIV 
            className: "monospaced #{if pic.dark then 'dark' else 'light'}"

            style: 
              position: 'absolute'
              top: pic.top or 50
              left: pic.left or 400
              color: if pic.dark then 'white' else 'black'
              width: (pic.width or 460) + 40
              fontSize: 22
              fontWeight: 500
              padding: "18px 28px"

            dangerouslySetInnerHTML: __html: ack.text



styles += """
  @media (max-width: 680px) {
    .acknowledgements {
      display: none;
    }
  }

  .acknowledgements .dark a {
    color: white;
  }
  .acknowledgements .light a {
    color: black;
  }

  .acknowledgements .dark, .acknowledgements .light {
    border-radius: 8px;
  }
  .acknowledgements .dark {
    background-color: rgba(0,0,0, .5);
  }
  .acknowledgements .light {
    background-color: rgba(255,255,255, .5);
  }
  .acknowledgement {
    min-height: 900px;
    position: relative;
    z-index: 2;
    background-size: cover;
    background-position: center;

    /* --mask: linear-gradient(#000 0 0) center/calc(100%) calc(100% - 25px) no-repeat, conic-gradient(from 135deg at top, #0000, #000 1deg 89deg, #0000 90deg) 0 0/25px 30px space no-repeat; #url(#{asset("product_page/acknowledgements/wave.png")}) */

    
    animation: wavy 150s infinite alternate linear;
  }
  @keyframes wavy {
    0%   { -webkit-mask: linear-gradient(#000 0 0) center/calc(100%) calc(100% - 93px) no-repeat, url(#{asset("product_page/wavy.png")}) repeat-x 0%     0%;
                   mask: linear-gradient(#000 0 0) center/calc(100%) calc(100% - 93px) no-repeat, url(#{asset("product_page/wavy.png")}) repeat-x 0%     0%;}
    100% { -webkit-mask: linear-gradient(#000 0 0) center/calc(100%) calc(100% - 93px) no-repeat, url(#{asset("product_page/wavy.png")}) repeat-x 10000% 0%;
                   mask: linear-gradient(#000 0 0) center/calc(100%) calc(100% - 93px) no-repeat, url(#{asset("product_page/wavy.png")}) repeat-x 10000% 0%;}
  }

"""


acknowledgements = 
  travis: 
    text: """
      Consider.it is led by <a href="https://traviskriplean.com" target="_blank">Travis Kriplean</a>. He first created it in 2010 as part of his PhD 
      research on <a href="https://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.229.2396&rep=rep1&type=pdf" target="_blank">Supporting Reflective Public Dialogue</a>. 
      He’s been working on it ever since. Contact him at <a href="mailto:travis@consider.it">travis@consider.it</a>, read <a href="https://traviskriplean.com" target="_blank">his blog</a>, or connect on <a href="https://www.linkedin.com/in/travis-kriplean/" target="_blank">LinkedIn</a>.
      """
    pics: [ {url: 'reading.jpeg', top: 100, width: 520, left: 50, dark: false}, {url: 'needles.jpeg', top: 100, width: 520, left: "calc(50% - 460px / 2)", dark: false}, {url: 'tetons.jpeg', top: 100, width: 520, left: 100, dark: false}]
  core: 
    text: """
      Consider.it benefits from deep contributions from many fantastic people, most substantially <a href="https://invisible.college/@toomim" target="_blank">Michael Toomim</a>, 
      <a target="_blank" href="https://www.linkedin.com/in/kevin-miniter/">#{if Math.random() > .5 then 'Kevin' else 'Kevie'} Miniter</a>, <a href="https://www.linkedin.com/in/ethanschaffer/" target="_blank">Ethan Schaffer</a>, and <a href="https://www.linkedin.com/in/evaring/" target="_blank">Eva Ringstrom</a>. 
      """
    pics: [{url: 'prototypin.jpeg', top: 100, left: 80, dark: false}, {url: 'crazy-mike.jpg', top: 100, left: 50, dark: true}, {url: 'laying.jpg', top: 100, left: 50, dark: false}] 
  early: 
    text: """
      Major contributors at the beginning of the project include <a href="https://www.cs.washington.edu/people/faculty/borning" target="_blank">Alan Borning</a>, <a href="https://www.dianedouglas.consulting/" target="_blank">Diane Douglas</a>, 
      <a href="https://www.linkedin.com/in/jonathan-t-morgan-phd-4019058/" target="_blank">Jonathan Morgan</a>, <a href="https://www.linkedin.com/in/jessica-jones-3560575/" target="_blank">Jessica Jones</a>, <a href="https://www.polisci.washington.edu/people/w-lance-bennett" target="_blank">Lance Bennett</a>, <a href="http://hussman.unc.edu/directory/faculty/deen-freelon" target="_blank">Deen Freelon</a>, and <a href="https://www.andrewhamada.com/" target="_blank">Andrew Hamada</a>. 
      """
    pics: [{url: 'cabin.jpg', top: 100, left: 50, dark: true}, {url: 'kev-beach.jpeg', top: 100, left: 50, dark: true}, {url: 'kev-ethan.jpg', top: 38, left: 38, dark: false}]











forms = [
  {
    id: 'general_inquiry'
    question: "General inquiry"
    fields: [
      {
        label: 'Your name'
        tag: INPUT
        optional: true
      }
      {
        label: 'Your email'
        tag: INPUT
        optional: false        
      }
      {
        label: 'Your organization'
        tag: INPUT
        optional: true        
      }
      {
        label: 'What can we help you with?'
        tag: TEXTAREA
        optional: false

      }

    ]
  }
  {
    id: 'request_demo'
    question: "Let's schedule a demo"
    fields: [
      {
        label: 'Your name'
        tag: INPUT
      }
      {
        label: 'Your email'
        tag: INPUT
      }
      {
        label: 'Your organization'
        tag: INPUT
      }
      {
        label: 'A basic description of your goal for a dialogue'
        tag: TEXTAREA
      }
      {
        label: 'How did you learn about Consider.it?'
        tag: TEXTAREA
        optional: true            
      }
    ]
  }
  {
    id: 'consulting_inquiry'
    question: 'Will your consulting services help my project?'
    fields: [
      {
        label: 'Your name'
        tag: INPUT
      }
      {
        label: 'Your email'
        tag: INPUT
      }
      {
        label: 'Your organization'
        tag: INPUT
      }
      {
        label: 'Describe your project'
        tag: TEXTAREA
      }
      {
        label: 'Approximate budget'
        tag: INPUT
        optional: true
      }
      {
        label: 'How did you learn about Consider.it?'
        tag: TEXTAREA
        optional: true
      }
    ]
  }
  {
    id: 'consultant_partnership'
    question: "I'm a consultant and would like to use Consider.it with my clients"
    fields: [
      {
        label: 'Your name'
        tag: INPUT
      }
      {
        label: 'Your email'
        tag: INPUT
      }
      {
        label: 'Your organization'
        tag: INPUT
      }
      {
        label: 'Describe your practice'
        tag: TEXTAREA
        optional: true
      }
      {
        label: 'How did you learn about Consider.it?'
        tag: TEXTAREA
        optional: true
      }
    ]
  }

  {
    id: 'upgrade_to_customized_forum'
    question: "We would like help with our Forum"
    fields: [
      {
        label: 'Your name'
        tag: INPUT
      }
      {
        label: 'Your email'
        tag: INPUT
      }
      {
        label: 'Your organization'
        tag: INPUT
      }
    ]
  }

  # {
  #   id: 'discount'
  #   question: "My project could use a discount..."
  #   fields: [
  #     {
  #       label: 'Your name'
  #       tag: INPUT
  #     }
  #     {
  #       label: 'Your email'
  #       tag: INPUT
  #     }
  #     {
  #       label: 'Your organization'
  #       tag: INPUT
  #     }
  #     {
  #       label: 'Why should your community\'s forum get a discount?'
  #       tag: TEXTAREA
  #     }
  #     {
  #       label: 'Approximate budget'
  #       tag: INPUT
  #     }
  #     {
  #       label: 'What do you need that the Free Forum does not provide?'
  #       tag: TEXTAREA
  #     }
  #     {
  #       label: 'How did you learn about Consider.it?'
  #       tag: TEXTAREA
  #       optional: true
  #     }
  #   ]
  # }
]


# team = -> 
#   members = [{
#       img: 'travis1'
#       name: "Travis Kriplean"
#       email: 'travis@consider.it'
#       location: 'Portland, OR'
#     },{
#       img: 'kevin1'
#       name: "Kevin Miniter"
#       email: 'kevin@consider.it'
#       location: 'Portland, OR'      
#     },{
#       img: 'mike1'
#       name: "Mike Toomim"
#       email: 'toomim@consider.it'
#       location: 'Montreal'
#     }
#   ]

#   DIV 
#     style: _.extend {}, base_text,
#       textAlign: 'center'
#       marginTop: 30

#     for t, idx in members
#       DIV
#         key: idx
#         style:
#           display: "inline-block"
#           margin: "20px 30px"
#           textAlign: "center"
#           width: 180


#         A
#           href: "mailto:#{t.email}"

#           IMG
#             src: asset("product_page/#{t.img}.jpg")
#             style:
#               borderRadius: "50%"
#               display: "inline-block"
#               width: 150
#               height: 150
#               textAlign: "center"  
#               boxShadow: "0px 2px 2px rgba(0,0,0,.1)"

#           BR null

#           SPAN
#             style: _.extend {}, a, 
#               textAlign: "center"
#               #borderBottom: 'none'
#               borderBottomColor: 'white'              
#               color: 'white'
#             t.name

#           BR null

#           SPAN 
#             style: _.extend {}, small_text

#             t.location

#           BR null

#           SPAN 
#             style: _.extend {}, small_text,
#               position: 'relative'
#               top: -7

#             t.email



/** WEBPACK FOOTER **
 ** ../wwwconsiderit/@client/product_page/contact.coffee
 **/